import { render, staticRenderFns } from "./login.vue?vue&type=template&id=64fb4672&scoped=true&"
import script from "./login.vue?vue&type=script&scoped=true&lang=js&"
export * from "./login.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./login.vue?vue&type=style&index=0&id=64fb4672&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fb4672",
  null
  
)

export default component.exports